import React, { useState, useEffect } from "react";
import { Grid } from "@mui/material";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import { getProxyApplicationLogs, getProxyApplication } from "../clients/FixieApiClient";
import SocksLogTable from "../components/SocksLogTable";
import HttpLogsTable from "../components/HttpLogsTable";
import Link from "../components/Link";
import DashboardPage from "../layouts/DashboardPage";

export default () => {
  const rpp = 20; // number of logs per page
  const navigate = useNavigate();
  const { id } = useParams();
  const [searchParams] = useSearchParams();
  const currentExclusiveStartKey = searchParams.get('exclusiveStartKey') || '';
  const [proxyLogs, setProxyLogs] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [nextExclusiveStartKey, setExclusiveStartKey] = useState();
  const [proxyType, setProxyType] = useState('');


  useEffect(() => {
    document.documentElement.scrollTo({
      top: 0,
      left: 0
    });
  }, [id, currentExclusiveStartKey]);

  useEffect(() => {
    const fetchLogs = async () => {
      setIsLoading(true);
      setProxyLogs([]);
      try {
        const detailResponse = await getProxyApplication(id!);
        const logsResponse = await getProxyApplicationLogs(id!, rpp, currentExclusiveStartKey);
        if (logsResponse.ok && detailResponse.ok) {
          const detailFetchResponse = await detailResponse.json();
          setProxyType(detailFetchResponse.proxyType);
          const logsFetchResponse = await logsResponse.json()
          const logs = logsFetchResponse && logsFetchResponse.logs
          const exclusiveStartKey = logsFetchResponse && logsFetchResponse.newLastKey
          setProxyLogs(logs);
          setExclusiveStartKey(exclusiveStartKey);
        }
      } finally {
        setIsLoading(false);
      }
    };

    fetchLogs();
  }, [id, currentExclusiveStartKey]);

  const nextLink = () => {
    if (proxyLogs.length === rpp) {
      const nextUrl = `${window.location.pathname}?exclusiveStartKey=${nextExclusiveStartKey}`
      return (
        <Link to={nextUrl} style={{ textDecoration: "none" }}>Next →</Link>
      )
    }
  }

  const previousLink = () => {
    if (currentExclusiveStartKey) {
      return (
        <Link onClick={() => { navigate(-1) }} style={{ textDecoration: "none" }}>← Previous</Link>
      )
    }
  }

  return (
    <DashboardPage title="Logs">
      {proxyType === 'http' ?
        <HttpLogsTable logs={proxyLogs} isFirstPage={!currentExclusiveStartKey} isLoading={isLoading} rpp={rpp} /> :
        <SocksLogTable logs={proxyLogs} isFirstPage={!currentExclusiveStartKey} isLoading={isLoading} rpp={rpp} />
      }
      <Grid container justifyContent="space-between" alignItems="center" padding="1rem">
        <Grid item>
          {previousLink()}
        </Grid>
        <Grid item>
          {nextLink()}
        </Grid>
      </Grid>
    </DashboardPage>
  );
}
